import React from "react";

import {Button, ModalBody, Modal} from 'reactstrap';

import {Card, CardContent} from "@material-ui/core";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import CustomerComponent from "./Parts/CustomerComponent";
import {Objects} from "../index";
import {formatLayawayMoney, layawayMoney, layawayRefundDue} from "../../utils/layawayRefundDue";

function layawayDisplaySubtotal(layaway) {
	const direct = layawayMoney(layaway?.sub_total_amount);
	if (direct > 0.005) {
		return direct;
	}
	const fromParts = layawayMoney(layaway?.taxable_subtotal) + layawayMoney(layaway?.non_taxable_subtotal);
	if (fromParts > 0.005) {
		return fromParts;
	}
	return Math.max(0, layawayMoney(layaway?.amount) - layawayMoney(layaway?.tax_amount));
}

function estimatedDateIsInPast(value) {
	if (!value) {
		return false;
	}
	const parsed = new Date(value);
	if (Number.isNaN(parsed.getTime())) {
		return false;
	}
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	parsed.setHours(0, 0, 0, 0);
	return parsed < today;
}

export default class Layaway extends Framework.Components.Object {
	constructor(props) {
		/**
		 *  @typedef {Layaways_Object} this.state
		 */
		super(props, Types.Layaways._name);
		this.state.updateEmailModal = false;
		this.state.customerAddModalOpen = false;
		this._loadedEstimatedDate = undefined;

		this.sendReceipt = this.sendReceipt.bind(this);
		this.afterCustomerSave = this.setNewObject('customer');
	}

	handleSubmit = async (ev) => {
		const estimatedChanged =
			this._loadedEstimatedDate !== undefined
			&& String(this.state.estimated_date || '') !== String(this._loadedEstimatedDate || '');
		if (estimatedChanged && estimatedDateIsInPast(this.state.estimated_date)) {
			API.Toast.error('Estimated payoff date cannot be in the past.', { position: API.Toast.POSITION.TOP_RIGHT });
			return;
		}
		await super.handleSubmit(ev);
		this._loadedEstimatedDate = this.state.estimated_date;
	}

	reloadContractHeader = async () => {
		const pkey = this.state.pkey || this.props.id;
		if (!pkey) {
			return;
		}
		try {
			let model = new API.BuildClass(Types.Layaways._name, API.RequestType.READ);
			model.object = {pkey};
			const response = await model.submit(null, 'GET', true);
			const o = response?.response ?? response?.object ?? response;
			if (!o || typeof o !== 'object') {
				return;
			}
			this.setState({
				sub_total_amount: o.sub_total_amount,
				taxable_subtotal: o.taxable_subtotal,
				non_taxable_subtotal: o.non_taxable_subtotal,
				tax_amount: o.tax_amount,
				amount: o.amount,
				remaining: o.remaining,
				cc_fees: o.cc_fees,
				amount_refunded: o.amount_refunded,
				tax_json: o.tax_json,
				completed_date: o.completed_date,
			});
		} catch (e) {
			// keep existing header totals if refresh fails
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (typeof(this.props.setRemaining) === 'function' && this.state.remaining !== prevState.remaining) {
			this.props.setRemaining(this.state.remaining)
		}
		if (this.state.loaded && !prevState.loaded) {
			this._loadedEstimatedDate = this.state.estimated_date;
			if (typeof this.props.setLayawayClosed === 'function') {
				const closed = this.state.completed_date != null && String(this.state.completed_date).trim() !== '';
				this.props.setLayawayClosed(closed);
			}
		}
		if (typeof this.props.setLayawayClosed === 'function') {
			const closed = this.state.completed_date != null && String(this.state.completed_date).trim() !== '';
			const wasClosed = prevState.completed_date != null && String(prevState.completed_date).trim() !== '';
			if (closed !== wasClosed) {
				this.props.setLayawayClosed(closed);
			}
		}
	}

	getCustomerEmail = () => {
		console.log(this.state.customer, this.state.customers)
		return this.state.customers && this.state.customers.email ? this.state.customers.email : '';
	}

	getLegacyCustomerName = () => {
		const notes = this.state.layaway_notes || '';
		const legacyRegex = /Legacy client information:\s*([^\n\r]+)/gi;
		let match = null;
		let name = '';
		while ((match = legacyRegex.exec(notes)) !== null) {
			name = match[1].trim();
		}
		return name;
	}

	getLegacyCustomerSeed = () => {
		return {
			name: this.getLegacyCustomerName(),
			email: this.state.receipt_email || '',
		};
	}

	handleCustomerCreatedForReceipt = async (data) => {
		if (typeof this.afterCustomerSave === 'function') {
			this.afterCustomerSave(data);
		}
		if (data && data.pkey && this.state.pkey) {
			await this.saveLayawayCustomer(data.pkey);
		}
		this.setState({
			customer: data && data.pkey ? data.pkey : this.state.customer,
			customers: data || this.state.customers,
			customerAddModalOpen: false,
			updateEmailModal: false,
		});
	}

	saveLayawayCustomer = async (customer) => {
		let layaway = new API.BuildClass(Types.Layaways._name, API.RequestType.UPDATE);
		layaway.object.pkey = this.state.pkey;
		layaway.object.customer = customer;
		await layaway.submit(null, API.RequestType.UPDATE, true);
	}

	//this.props.attemptedSave could be an issue
	sendReceipt = async () => {
		const customerEmail = this.getCustomerEmail();
		if (!this.state.customer || !customerEmail) {
			this.setState({updateEmailModal: true})
			return;
		}
		if (!this.state.pkey || !this.state.pkey) return;
		await this.saveLayawayCustomer(this.state.customer);
		//this.state.method = "terminal";
		this.setState({loading: true});
		await this.model.submit(this, 'POST_EMAIL', false).then(() => {
			this.setState({loading: false});
			if (typeof(this.props.attemptedSave) !== "undefined") {
				this.props.attemptedSave(true)
			}
		})

		this.setState({loading: false});
	}

	render() {
		/**
		 * @type {Layaways_Properties} properties
		 */
		let properties = this.model.properties;
		/**
		 *  @type {Layaways_Object} object
		 */
		let object = this.state;

		return <Card>
			<CardContent>
				<h4 className="section-title">Layaway Details</h4>
				<div>
					<div className={'row'}>
						<div className={'col-12'}>
							<CustomerComponent
								locations={this.props.locations || []}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterCustomerSave={this.afterCustomerSave}
								onPersistCustomer={this.saveLayawayCustomer}
								key={object.customer ? `customer_layaway_${object.customer}` : "customer_layaway"}
							/>
						</div>
					</div>
					<div className={'form-group'}>
						<Framework.Elements.TextField
							name={"description"}
							label={"Layaway Description (Shown On Receipt)"}
							placeholder={"Public description about layaway"}
							property={properties.description}
							value={object.description}
							error={object.description_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</div>
					<hr/>
					<div className={'form-group'}>
						<Framework.Elements.TextField
							name={"layaway_notes"}
							label={"Layaway Notes (Shown On Receipt)"}
							placeholder={"Public notes about layaway"}
							property={properties.layaway_notes}
							value={object.layaway_notes}
							error={object.layaway_notes_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</div>
					<hr/>
					<div className={'form-group'}>
						<Framework.Elements.TextField
							name={"customer_notes"}
							label={"Customer Notes (Not Shown On Receipt)"}
							placeholder={"Private notes about layaway"}
							property={properties.customer_notes}
							value={object.customer_notes}
							error={object.customer_notes_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</div>
				</div>
				<div className={"row"}>
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.Date
								label={"Completed Date (set to close layaway)"}
								value={object.completed_date}
								error={object.completed_date_error}
								property={properties.completed_date}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.Date
								label={"Estimated Date"}
								value={object.estimated_date}
								error={object.estimated_date_error}
								property={properties.estimated_date}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
				</div>
				<div className={"row"}>
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								error={object.sub_total_amount_error}
								value={layawayDisplaySubtotal(object)}
								property={properties.sub_total_amount}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								error={object.tax_amount_error}
								value={object.tax_amount}
								property={properties.tax_amount}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
					<div className={"col"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								label={"Total"}
								error={object.amount_error}
								value={object.amount}
								property={properties.amount}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
				</div>
				{layawayRefundDue(object.remaining) > 0.005 ? (
					<div
						className="alert alert-warning"
						role="alert"
						style={{marginBottom: 16}}
					>
						<strong>Refund due to customer: ${formatLayawayMoney(layawayRefundDue(object.remaining))}</strong>
						<div className="small" style={{marginTop: 6}}>
							The contract balance is a credit (remaining is negative). Use the <strong>Refund</strong> button
							in the toolbar. If the payment exceeds the refund due, use a <strong>restocking fee</strong> so
							only the cash-back portion clears the credit.
						</div>
					</div>
				) : null}
				<div className={"row"}>
					<div className={"col-4"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								error={object.cc_fees_error}
								value={object.cc_fees}
								property={properties.cc_fees}
								label={"CC Fees Collected"}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
					<div className={"col-4"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								error={object.remaining_error}
								value={object.remaining}
								property={properties.remaining}
								label={layawayRefundDue(object.remaining) > 0.005
									? "Contract balance (credit)"
									: "Remaining"}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
					<div className={"col-4"}>
						<div className={"form-group"}>
							<Framework.Elements.DollarAmount
								label={"Amount Refunded"}
								error={object.amount_refunded_error}
								value={object.amount_refunded}
								property={properties.amount_refunded}
								update={this.handleTextFieldPropertyUpdate}
								disabled={true}
							/>
						</div>
					</div>
				</div>

				<div style={{display: 'grid'}}>
					<Button className="primary-button" onClick={this.handleSubmit} style={{justifySelf: 'end'}}>Save</Button>
				</div>
			</CardContent>

			<Modal
				isOpen={this.state.updateEmailModal}
				toggle={() => {this.setState({updateEmailModal: false})}}
				size={"md"}
				backdrop={true}
			>
				<ModalBody>
					<div className={'d-flex flex-column'}>
						<b style={{justifySelf: "center", paddingBottom: '1rem'}}>
							{!this.state.customer
								? 'This layaway needs a customer before a receipt can be emailed.'
								: 'The selected customer needs an email address before a receipt can be emailed.'}
						</b>
						{!this.state.customer && this.getLegacyCustomerName() &&
							<p>
								Found legacy customer information: <strong>{this.getLegacyCustomerName()}</strong>
								{this.state.receipt_email ? <> with email <strong>{this.state.receipt_email}</strong></> : null}.
							</p>}
						{this.state.customer && !this.getCustomerEmail() &&
							<p>Please edit the selected customer and add an email address, then try sending the receipt again.</p>}
						<div className={'justify-content-between full-width d-flex py-1'}>
							<Button
								color={'danger'}
								size={"sm"} block={false}
								onClick={() => {this.setState({updateEmailModal: false})}}
							>
								Cancel
							</Button>
							{!this.state.customer &&
								<Button
									color={'success'}
									size={"sm"} block={false}
									onClick={() => this.setState({customerAddModalOpen: true})}
								>
									Create Customer
								</Button>}
						</div>
					</div>
				</ModalBody>
			</Modal>
			<Framework.Elements.UniversalModal
				locations={this.props.locations || []}
				history={this.props.history}
				name={"Customer"}
				object={Objects.Customer}
				showModal={this.state.customerAddModalOpen}
				objectProps={{
					object: this.getLegacyCustomerSeed(),
					hideSave: true
				}}
				handleToggle={() => this.setState({customerAddModalOpen: !this.state.customerAddModalOpen})}
				afterSave={this.handleCustomerCreatedForReceipt}
				url={'customers'}
			/>

		</Card>
	}
}
